<template>
  <div v-loading="loading" >


    <el-row class="m-20">
      <el-col>
        <el-button type="primary" @click="openLabelDialog" style="float:right" >Ajouter un nouveau type</el-button>
        <span class="fs-14" v-if="!isProductTypesEmpty">Types de produit</span>
      </el-col>
    </el-row>
    <el-tabs v-model="activeNames" class="m-20" tabPosition="top">
      <el-tab-pane v-for="(type, index) in productTypes" :key="type.id" :label="type.name.fr +' / ' + type.name.en" :name="type.code" >
        <span class="fs-14">Type de produit : </span>
        <div  class="p-5 border m-5">
          <el-row type="flex">
            <el-col :span="18" class="m-5">
              <span class="fs-14">{{type.name.fr}} / {{type.name.en}} </span>
            </el-col>
            <el-col :span="6" class="text-right align-vertical-middel">
              <el-button
                size="mini"
                circle
                @click="editProductType(type, index)"
                ><i class="mdi mdi-lead-pencil fs-14"></i></el-button>
              <el-button
                size="mini"
                type="danger"
                circle
                @click="handleDeleteProductType(type, index)"
                ><i class="mdi mdi-delete fs-14" ></i></el-button>
            </el-col>
          </el-row>
        </div>

        <el-divider/>
        <h5>Sous-types de produit</h5>
        <el-row>
          <el-col class="text-right">
            <el-button size="small" @click="openSpecificLabelDialog(type)">Ajouter un sous-type</el-button>
          </el-col>
        </el-row>
        <div  v-for="specific in type.specifics" :key="specific.id" class="p-5 border m-5">
          <el-row type="flex">
            <el-col :span="18" class="m-5">
              <span class="fs-14">{{specific.name.fr}} / {{specific.name.en}} </span>
            </el-col>
            <el-col :span="6" class="text-right align-vertical-middel">
              <el-button
                size="mini"
                circle
                @click="handleSpecificTypeEdition(specific, type)"
                ><i class="mdi mdi-lead-pencil fs-14"></i></el-button>
              <el-button
                size="mini"
                type="danger"
                circle
                @click="handleDeleteProductSpecificType(specific, type)"
                ><i class="mdi mdi-delete fs-14" ></i></el-button>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div v-if="isProductTypesEmpty" class="text-center">
      <span class="fs-14">Il n'y a aucun type de produit!</span>
    </div>
    <LabelDialog :visible="specificLabelDialogVisible" @add="handleAddSpecificProductType" @update="handleSpecificProductTypeUpdated" :edit="labelToEdit" @close="closeSpecificLabelDialog" title="specificProductType"></LabelDialog>
    <LabelDialog :visible="labelDialogVisible" @add="handleAddProductType" @update="handleProductTypeUpdated" :edit="labelToEdit" @close="closeLabelDialog" title="productType"></LabelDialog>
  </div>
</template>
<script>

import CMSApi from '@/services/API/cmsAPI'
import LabelDialog from './label-dialog'
import Promise from 'bluebird'
import slugify from 'slugify'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'ProductTypesController',
  props : {

  },
	data() {
		return {
      activeNames : 0,
      productTypeToEdit : null,
      specificTypeToEdit : null,
      labelToEdit : null,
      productTypes : [],
      loading : false,
      labelDialogVisible : false,
      specificLabelDialogVisible : false
		}
	},
  components : {
    LabelDialog
  },
  computed : {
    isProductTypesEmpty(){
      return this.productTypes.length==0;
    },
    cmsLanguages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    ...mapState('controlData',['languages', 'countries']),
  },
  methods : {
    handleSpecificTypeEdition(specific, type){
      this.specificTypeToEdit = specific;
      this.labelToEdit = specific.name;
      this.openSpecificLabelDialog(type);
    },
    openSpecificLabelDialog(type){
      this.productTypeToEdit = type;
      this.specificLabelDialogVisible=true;
    },
    closeSpecificLabelDialog(type){
      this.labelToEdit = null;
      this.specificLabelDialogVisible=false;
    },
    handleAddSpecificProductType(specificTypesLabel){
      let newSprecificProductType = {
        code : slugify(specificTypesLabel.fr),
        name : specificTypesLabel,
        type : {id : this.productTypeToEdit.id}
      }
      return CMSApi.saveProductSpecificTypes(newSprecificProductType)
        .then(()=>this.$message.success("Le nouveau type spécifique a été ajouté avec succès!"))
        .then(()=>this.init(this.productTypeToEdit.code))
        .catch(err=>{
          console.log(err);
          this.$message.error("Oops... Une erreur est survenue!");
        })
    },
    handleSpecificProductTypeUpdated(labels){
      let productTypeCode = this.productTypeToEdit.code;
      this.specificTypeToEdit.name = labels;
      return CMSApi.updateProductSpecificTypes(this.specificTypeToEdit.id, this.specificTypeToEdit)
        .then(()=>this.$message.success("Le sous-type de produit a été renommé avec succès!"))
        .then(()=>this.init(productTypeCode))
        .catch(err=>{
          console.log(err);
          this.$message.error("Oups... Une erreur est survenue!");
        })
    },
    handleDeleteProductSpecificType(specificType, type){
      this.$confirm('Ceci supprimer le sous-type de produit de façon permanente. Continuer?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
      }).then(()=>CMSApi.deleteProductSpecificTypes(specificType.id))
        .then(()=>this.$message.success('Le sous-type de produit a été supprimé!'))
        .then(()=>this.init(type.code))
        .catch(err=>{
          if(err=="cancel"){
            this.$message("Suppression annulée!")
          }else{
            console.log(err);
            this.$message.error("Oops... Une erreur est survenue!");
          }
        })
    },
    handleAddProductType(name){
      let newProductType = {
        code : slugify(name.fr),
        name
      }
      this.loading = true
      return CMSApi.saveProductTypes(newProductType)
        .then(()=>this.$message.success("Le nouveau type de produit a été ajouté avec succès!"))
        .then(()=>this.init(newProductType.code))
        .catch(err=>{
          console.log(err);
          this.$message.error("Oops... Une erreur est survenue!")
        })

    },
    editProductType(productType, index){
      this.productTypeToEdit = productType;
      this.labelToEdit = productType.name;
      this.openLabelDialog();
    },
    handleProductTypeUpdated(label){
      let productTypeCode = this.productTypeToEdit.code;
      this.productTypeToEdit.name = label;
      return CMSApi.updateProductTypes(this.productTypeToEdit.id, this.productTypeToEdit)
        .then(()=>this.$message.success("Le type de produit a été renommé avec succès!"))
        .then(()=>this.init(productTypeCode))
        .catch(err=>{
          console.log(err);
          this.$message.error("Oups... Une erreur est survenue!");
        })
    },
    handleDeleteProductType(productType, index){
      this.$confirm('Ceci supprimer le type de produit de façon permanente. Continuer?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
      })
      .then(()=>CMSApi.deleteProductTypes(productType.id))
      .then(()=>this.$message.success('Le type de produit a été supprimé!'))
      .then(()=>this.init())
      .catch(err=>{
        if(err=="cancel"){
          this.$message("Suppression annulée!")
        }else{
          console.log(err);
          this.$message.error("Oops... Une erreur est survenue!");
        }
      })
    },
    openLabelDialog(){
      this.labelDialogVisible = true;
    },
    closeLabelDialog(){
      this.productTypeToEdit = null;
      this.labelToEdit = null;
      this.labelDialogVisible = false;
    },
    fetchProductTypes(){
      return CMSApi.fetchProductTypes()
        .then(productTypes=>{
          this.productTypes = productTypes;
        })
    },
    setModel(){
      // _.forEach(this.productTypes, t=>{
      //   this.$set(this.model, t.code, [])
      //   // this.model[t.code] = [];
      // })
      // _.forEach(this.productItemPropertyLabels, s=>{
      //   s.deleted = false;
      //   s.new = false;
      //   s.updated = false;
      //   this.model[s.productType.code].push(s);
      // })
    },
    init(activeTab){
      this.loading = true;
      return this.fetchProductTypes()
        .then(()=>this.setModel())
        .then(()=>{
          if(activeTab){
            this.activeNames = activeTab;
          }else{
            this.activeNames = this.productTypes != null && this.productTypes.length > 0 ? this.productTypes[0].code : null;
          }
          this.loading = false;
        })
    },
    ...mapActions('controlData',['fetchLanguages'])

  },
  mounted(){
    this.loading = true;
    this.fetchLanguages();
    return this.init();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';



</style>
